import Vue from "vue";
import {Base64Decode} from "@azure/msal-browser/dist/encode/Base64Decode";

class ConfigManager{
    private _configManager : {
        disabletranslations: boolean
        modifyDynamicComponents: boolean
        debugDynamicComponents: boolean
        editAllDynamicComponents: boolean
        showHiddenDynamicComponents: boolean
    } = this.readConfigManager();

    private readConfigManager() {
        return JSON.parse(this.base64Decode(localStorage.getItem('configManager')) || JSON.stringify({
            disabletranslations: false,
            modifyDynamicComponents: false,
            debugDynamicComponents: false,
            editAllDynamicComponents: false,
            showHiddenDynamicComponents: false
        }));
    }

    private storeConfigManager() {
        const enc = this.base64Encode(JSON.stringify(this._configManager))
        if(enc){
            localStorage.setItem('configManager', enc);
        }
    }

    private base64Encode(str) {
        if(!str) return null;
        return btoa(unescape(encodeURIComponent(str)));
    }

    private base64Decode(str) {
        if(!str) return null;
        return decodeURIComponent(escape(atob(str)));
    }


    constructor() {
        return;
    }

    translationsDisabled(): boolean {
        return this._configManager.disabletranslations;
    }

    debugDynamicComponentsEnabled(): boolean {
        return this._configManager.debugDynamicComponents;
    }

    modifyDynamicComponentsEnabled(): boolean {
        return this._configManager.modifyDynamicComponents;
    }
    showHiddenDynamicComponentsEnabled(): boolean {
        return this._configManager.showHiddenDynamicComponents;
    }

    editAllDynamicComponentsEnabled(): boolean {
        return this._configManager.editAllDynamicComponents;
    }

    setConfig(formData: any) {
        this._configManager = formData;
        this.storeConfigManager();
    }

    getConfig() {
        return this._configManager;
    }
}
export const configManager = new ConfigManager();

export function onHotkey({ ctrlOrCmd = false, alt = false, key, callback }) {
    window.addEventListener('keydown', (e) => {
        if(!e || !e.target) return;
        // Don't trigger while typing in input, textarea, or contenteditable
        const tag = e.target["tagName"];
        const isTyping = tag === 'INPUT' || tag === 'TEXTAREA' || e.target["isContentEditable"];

        if (isTyping) return;

        const hasCtrlOrCmd = ctrlOrCmd ? (e.ctrlKey || e.metaKey) : true;
        const hasAlt = alt ? e.altKey : true;
        const isKey = e.key.toLowerCase() === key.toLowerCase();

        if (hasCtrlOrCmd && hasAlt && isKey) {
            e.preventDefault(); // optional: block browser shortcut
            callback(e);
        }
    });
}
